import React from 'react'
import { FormB1 as FormB1Type } from '@chegg-wt/core/types/core'
import { LvpMarginWrapper } from '../../Layouts/LargeVideoPlayerLayout'
import * as Styled from './styled'

interface Props {
  copy: FormB1Type
}

const FormB1: React.FC<Props> = ({ copy }) => (
  <LvpMarginWrapper>
    <Styled.Wrapper className="results">
      <div className="container-fluid" id="content-addition">
        <Styled.HeadingContainer>
          <Styled.ContentHeading size="md">{copy.header}</Styled.ContentHeading>
        </Styled.HeadingContainer>
        <div className="row">
          {copy.table.map((question) => (
            <Styled.Container key={question.header}>
              <Styled.ListHeader>{question.header}</Styled.ListHeader>
              <Styled.Body>{question.bodyHeader}</Styled.Body>
              <Styled.QuestionUL>
                {question.body && question.body.map((item) => <li key={item}>{item}</li>)}
              </Styled.QuestionUL>
            </Styled.Container>
          ))}
        </div>
      </div>
    </Styled.Wrapper>
  </LvpMarginWrapper>
)

export default FormB1
